import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { LogOut } from 'lucide-react'
import Logo from '../ui/Logo'
import TrialBadge from '../caja/TrialBadge'

export default function CajaLayout({ children }) {
  const { profile, signOut } = useAuth()
  const navigate = useNavigate()

  async function handleSignOut() {
    await signOut()
    navigate('/login')
  }

  return (
    <div className="min-h-screen bg-cream-50">
      {/* Top nav */}
      <header className="bg-brand-800 text-cream-100 sticky top-0 z-10 shadow-sm">
        <div className="max-w-5xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
          {/* Brand */}
          <div
            className="flex items-center gap-3 cursor-pointer group"
            onClick={() => navigate('/caja')}
          >
            <Logo variant="mark" className="text-cream-100 group-hover:text-accent-400 transition-colors" size={32} />
            <div className="flex items-baseline gap-2">
              <span className="font-display text-base tracking-wider text-cream-100">NEXT VALLEY</span>
              <span className="hidden sm:block text-[10px] font-medium text-accent-400 bg-accent-500/15 border border-accent-500/30 px-2 py-0.5 rounded-full uppercase tracking-wider">
                Estrategia en una Caja
              </span>
            </div>
          </div>

          {/* User + trial countdown */}
          <div className="flex items-center gap-3">
            <TrialBadge variant="header" onClick={() => navigate('/caja')} />
            <span className="hidden md:block text-sm text-steel-400 truncate max-w-[140px]">
              {profile?.full_name}
            </span>
            <button
              onClick={handleSignOut}
              className="flex items-center gap-1.5 text-xs text-steel-400 hover:text-accent-400 transition-colors px-2 py-1.5 rounded-lg hover:bg-white/5"
            >
              <LogOut size={14} /> Salir
            </button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-4 md:px-6 py-8">
        {children}
      </main>

      {/* Footer */}
      <footer className="text-center py-8 text-xs text-steel-500 flex items-center justify-center gap-2">
        <Logo variant="mark" className="text-brand-800" size={18} />
        <span>Next Valley · <span className="font-medium text-brand-800">Strategic Partners</span></span>
      </footer>
    </div>
  )
}
